// src/pages/HomePage.jsx
import React, { useEffect, useState, useRef } from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import axios from 'axios';
import { useLocation } from 'react-router-dom';
import '../utils/HomePage.css';
import QuienesSomos from './QuienesSomos';
import Consultas from './Consultas';
import LoginPage from './LoginPage';
import ComoFunciona from './ComoFunciona';
import Footer from './Footer';
import logo from '../components/public/llave1.jpg';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000';
const WHATSAPP_NUMBER = '593983930386'; // Reemplaza con tu número completo + código país (Ecuador: 593)

const HomePage = () => {
  const [tarifaData, setTarifaData] = useState({
    tarifa_base: 0,
    valor_base: 0,
    tarifa_exceso: 0,
    porcentaje_mora: 0,
    monto_registro_socio: 0,
    monto_reconexion: 0,
    nombre_aplicacion: ''
  });

  const [showHeader, setShowHeader] = useState(true);
  const [showFooter, setShowFooter] = useState(false);
  const lastScrollY = useRef(0);

  const homeRef = useRef(null);
  const aboutRef = useRef(null);
  const contactRef = useRef(null);
  const howItWorksRef = useRef(null);
  const loginRef = useRef(null); // ✅ NUEVA REFERENCIA
  const location = useLocation();

  useEffect(() => {
    const fetchTarifaData = async () => {
      try {
        const response = await axios.get(`${API_URL}/tarifas`);
        if (response.data.length > 0) {
          const data = response.data[0];
          setTarifaData({
            tarifa_base: data.tarifa_base,
            valor_base: data.valor_base,
            tarifa_exceso: data.tarifa_exceso,
            porcentaje_mora: data.porcentaje_mora,
            monto_registro_socio: data.monto_registro_socio,
            monto_reconexion: data.monto_reconexion,
            nombre_aplicacion: data.nombre_aplicacion
          });
        }
      } catch (error) {
        console.error('Error fetching tarifas data:', error);
      }
    };
    fetchTarifaData();
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;

      if (windowHeight + currentScrollY >= documentHeight - 10) {
        setShowFooter(true);
      } else {
        setShowFooter(false);
      }

      if (currentScrollY > lastScrollY.current && currentScrollY > 100) {
        setShowHeader(false);
      } else {
        setShowHeader(true);
      }

      lastScrollY.current = currentScrollY;
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (ref) => {
    ref.current?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="homepage-container">
      {showHeader && (
        <header className="homepage-header">
          <div className="logo">
            <h3>{tarifaData.nombre_aplicacion}</h3>
          </div>
          <nav className="homepage-navbar">
            <button onClick={() => scrollToSection(homeRef)}>Inicio</button>
            <button onClick={() => scrollToSection(aboutRef)}>Quiénes somos</button>
            <button onClick={() => scrollToSection(contactRef)}>Consultas</button>
            <button onClick={() => scrollToSection(howItWorksRef)}>Cómo funciona</button>
            <button className="btn-green" onClick={() => scrollToSection(loginRef)}>Empezar</button>
          </nav>
        </header>
      )}

      <main className="homepage-main">
        <br /><br />
        <section ref={homeRef} className="intro-section fade-in">
          <div className="intro-texts">
            <h2>Valores base del servicio:</h2>
          </div>
          <div className="intro-imagen">
            <img src={logo} alt="Logo" />
          </div>
        </section>

        <div className="stats fade-in">
          <div className="stat">
            <h3>{tarifaData.tarifa_base}m³</h3>
            <p>Tarifa Base</p>
          </div>
          <div className="stat">
            <h3>${tarifaData.valor_base}</h3>
            <p>Valor de la Base</p>
          </div>
          <div className="stat">
            <h3>${tarifaData.tarifa_exceso}</h3>
            <p>Adicional por m³</p>
          </div>
          <div className="stat">
            <h3>{tarifaData.porcentaje_mora}</h3>
            <p>Valor de Mora $</p>
          </div>
        </div>

        <div className="titulo fade-in">
          <h2>Valores adicionales del servicio:</h2>
        </div>

        <div className="stats1 fade-in">
          <div className="stat1">
            <h3>${tarifaData.monto_registro_socio}</h3>
            <p>Costo por nuevos socios</p>
          </div>
          <div className="stat1">
            <h3>${tarifaData.monto_reconexion}</h3>
            <p>Costo por reconexión</p>
          </div>
        </div>

        <section ref={aboutRef} className="fade-in">
          <QuienesSomos />
        </section>
        <br /><br />
        <section ref={contactRef} className="fade-in">
          <Consultas />
        </section>
        <section ref={howItWorksRef} className="fade-in">
          <ComoFunciona />
        </section>
        <br /><br /><br /><br /><br />
        {/* ✅ NUEVA SECCIÓN DE FORMULARIO LOGIN */}
        <section ref={loginRef} className="fade-in">
          <LoginPage />
        </section>
        <br /><br /><br /><br /><br /><br /><br /><br /><br /><br />
      </main>

      {/* Ícono flotante WhatsApp */}
      <a
        href={`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent('Hola, vi su sitio web y estoy interesado en su sistema. ¿Podrían darme más información o una cotización?')}`}
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-floating"
        aria-label="Chat WhatsApp"
      >
        <FaWhatsapp size={40} color="#25D366" />
        <span className="whatsapp-text">¿Dudas? Escríbeme</span>
      </a>
        {showFooter && <Footer />}
    </div>
  
  );
};

export default HomePage;
